// @import_dependencies
// @end

// @import services
// @end

// @import utilities
// @end

// @import types
// @end

class TimeService {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {}

  /**
   * @INFO Formatear segundos a diferentes formatos
   * @param _seconds
   * @returns
   */
  public secondsFormatHMS = (_seconds: number, _format: 'HH:MM:SS' | 'MM:SS' | 'HH:MM' | 'HHh MMm' | 'HHh' | 'HH') => {
    let result = ''
    if (typeof _seconds !== 'number') {
      _seconds = Number(_seconds);
    }
    const hours = Math.trunc(_seconds/3600);
    const minutes = Math.trunc((_seconds - (hours*3600))/60);
    const seconds = Math.trunc(_seconds - (minutes*60) - (hours*3600));
    switch(_format){
      case 'HH:MM:SS':
        result = `${this.getStringValue(hours)}:${this.getStringValue(minutes)}:${this.getStringValue(seconds)}`;
        break;
      case 'MM:SS':
        result = `${this.getStringValue(minutes)}:${this.getStringValue(seconds)}`;
        break;
      case 'HH:MM':
        result = `${this.getStringValue(hours)}:${this.getStringValue(minutes)}`;
        break;
      case 'HHh MMm':
        result = new Date(_seconds * 1000).toISOString().substr(11, 5);
        result = `${this.getStringValue(hours)}h ${this.getStringValue(minutes)}m`;
        break;
      case 'HHh':
        result = `${this.getStringValue(hours)}h`;
        break;
      case 'HH':
        result = this.getStringValue(hours);
        break;
      default:
        break;
    }
    return result
  }

  private getStringValue = (value: number) => {
    if (value < 10) {
      return `0${value}`;
    } else {
      return `${value}`;
    }
  }

}

export default TimeService
